import source from '../levels/levels.json' with { type: 'json' };

// The shipped collection is application data, never editable library content.
// Gameplay and custom copies get their own layouts; there is no admin override.
const Originals = Object.freeze(source.map(board => Object.freeze({
    ...board,
    layout: Object.freeze([...board.layout])
})));

export default Originals;
